import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {
  company?: string
  street?: string
  zipCode?: string
  city?: string
  webAdress?: string
  contact?: string
  phone?: string
  fax?: string
  email?: string
}

export type Variables = {
  company?: string
  street?: string
  zipCode?: string
  city?: string
  webAdress?: string
  contact?: string
  phone?: string
  fax?: string
  email?: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const COMPANY_DATA_MUTATION = gql`
  mutation setCompanyData(
    $company: String
    $street: String
    $zipCode: String
    $city: String
    $webAdress: String
    $contact: String
    $phone: String
    $fax: String
    $email: String
  ) {
    setCompanyData(
      company: $company
      street: $street
      zipCode: $zipCode
      city: $city
      webAdress: $webAdress
      contact: $contact
      phone: $phone
      fax: $fax
      email: $email
    )
  }
`

const withCompanyDataMutation = graphql<InputProps, Response, Variables, ChildProps>(
  COMPANY_DATA_MUTATION,
)

export default withCompanyDataMutation
